import React, { useEffect, useState } from "react";
import { Box } from "@material-ui/core";

import Swal from "sweetalert2";
import { MutantApiService } from "../../../../services/MutantApiService";

const MetricsTable = ({ streamingMetrics }) => {
  const createTableRows = (data) => {
    return Object.entries(data).map(([key, value], index) => {
      return (
        <tr key={index}>
          <td>{key}</td>
          <td>{JSON.stringify(value)}</td>
        </tr>
      );
    });
  };

  return (
    <Box>
      <h4>Metricas de modelo padrão</h4>
      <table>
        <thead>
          <tr>
            <th>Metric</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          {streamingMetrics && createTableRows(streamingMetrics)}
        </tbody>
      </table>
    </Box>
  );
};

const MetricsContainer = () => {
  const [streamingMetrics, setStreamingMetrics] = useState(null);
  const api = new MutantApiService();

  useEffect(() => {
    const fetchMetrics = async () => {
      try {
        const response = await api.makeHttpRequest({
          method: "GET",
          url: `/metrics/metrics/stream`,
        });
        if (response.gpu_info == null) {
          response.gpu_info = "GPU Não disponível";
        } else {
          response.gpu_info = JSON.stringify(response.gpu_info);
        }
        setStreamingMetrics(response);
      } catch (e) {
        console.error("Error fetching metrics:", e);
      }
    };

    fetchMetrics();
  }, []);

  return <MetricsTable streamingMetrics={streamingMetrics} />;
};

export default MetricsContainer;